import { yupResolver } from '@hookform/resolvers/yup'
import React from 'react'
import { physicalVS } from 'services/validations/catalog/physical'
import { CustomFormProps } from 'types/common'
import PhysicalFacetSection from 'ui-shared/Facets/FacetFormSections/PhysicalFacetSection'
import ExperienceForm from 'ui-shared/Forms/ExperienceForm'
import PhysicalKeyInfoSection from './PhysicalKeyInfoSection'

const PhysicalExperiencesForm: React.FC<CustomFormProps> = (props) => (
  <ExperienceForm
    {...props}
    resolver={yupResolver(physicalVS)}
    upsellingEntity="physicalupselling"
    facetFields={<PhysicalFacetSection />}
    slotBeforeHighlights={<PhysicalKeyInfoSection />}
  />
)

export default PhysicalExperiencesForm
